var _style, _desc, _path, _circle, _desc2, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOddiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    #light-icon {\r\n      display: inline;\r\n    }\r\n    #dark-icon {\r\n      display: none;\r\n    }\r\n\r\n    @media (prefers-color-scheme: dark) {\r\n      #light-icon {\r\n        display: none;\r\n      }\r\n      #dark-icon {\r\n        display: inline;\r\n      }\r\n    }\r\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "light-icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.625,0,0,15.625,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-labelledby": titleId,
    width: 64,
    height: 64,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Oddiss brand mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "An organic black ring containing an orange dot.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 6C43 5 53 11 57 21c5 12 0 24-9 30-8 5-24 8-33 6-6-1-9-5-9-11L5 31C4 19 12 10 23 7c3-1 6-1.3 8-1Z",
    fill: "none",
    stroke: "#171712",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 29,
    r: 7.25,
    fill: "#ff5d2f"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "dark-icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.625,0,0,15.625,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-labelledby": titleId,
    width: 64,
    height: 64,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Oddiss reversed brand mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc2 || (_desc2 = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "An organic white ring containing an orange dot, for dark backgrounds.")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6C43 5 53 11 57 21c5 12 0 24-9 30-8 5-24 8-33 6-6-1-9-5-9-11L5 31C4 19 12 10 23 7c3-1 6-1.3 8-1Z",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 29,
    r: 7.25,
    fill: "#ff5d2f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOddiss);
export default __webpack_public_path__ + "static/media/oddiss.28d4c8baf477dc2333f0577687132689.svg";
export { ForwardRef as ReactComponent };